<div class="repairs__section repairs__section--summary">
    <div *ngIf="loading">
        <app-spinner></app-spinner>
    </div>
    <form action="#" *ngIf="repairSummary.sors">
        <h2 *ngIf="repairSummary">{{pageSubHeading}}</h2>

        <table class="table table-striped" *ngIf="repairSummary?.sors">
            <thead>
                <tr>
                    <th>Repair</th>
                    <th class="col-xs-2">Qty</th>
                    <th class="col-xs-2"><span class="sr-only">Action</span></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let sor of repairSummary.sors">
                    <td>
                        <i class="table__icon table__icon--repair" aria-hidden="true"></i>
                        {{sor.description}}
                    </td>
                    <td>
                        {{sor.quantity}}
                    </td>
                    <td>

                        <button type="button" class="btn btn-block btn-remove" style="position:relative;"
                            (click)="deleteSor(sor.sorCode)" id="btn-{{sor.sorCode}}">
                            <span class="is-tablet-only">Remove</span>
                            <!-- <span us-spinner="{color: 'white'}" spinner-key="removeSorSpinner-{{sor.sorCode}}"></span> -->
                            <i class="fa fa-close" aria-hidden="true"></i>
                        </button>
                    </td>
                </tr>

            </tbody>
        </table>

        <div class="btn-set clearfix">
            <a href="/repairs/book-a-repair/" class="btn btn-default btn-send" id="btn-add">Add another repair</a>
        </div>

        <div class="btn-set clearfix">
            <a href="/repairs/appointments/" class="btn btn-primary btn-send" id="btn-continue">Continue to booking</a>
        </div>
    </form>

    <div *ngIf="repairSummary && !repairSummary.sors">

        <p>You've not selected any repairs</p>

        <span *ngIf="(roleNuvu === 'False') && (rolePrs === 'False')">
            <a href="/repairs/book-a-repair/" class="table__btn btn btn-secondary"><i class="fa fa-warning"
                    aria-hidden="true"></i>Book a repair</a>
        </span>

        <span *ngIf="(roleNuvu === 'True')">
            <a href="/repairs/report-a-repair-nuvu/" class="table__btn btn btn-secondary"><i class="fa fa-warning"
                    aria-hidden="true"></i>Book a repair</a>
        </span>

        <span *ngIf="(rolePrs === 'True')">
            <a href="/repairs/report-a-repair-prs/" class="table__btn btn btn-secondary"><i class="fa fa-warning"
                    aria-hidden="true"></i>Book a repair</a>
        </span>


    </div>

</div>